// Module
var code = `<p>manual-access works!</p> `;
// Exports
export default code;